import { genericHookContextBuilder } from '../util/genericHookContextBuilder';
import { useState } from 'react';

function useGame() {
    const [solutionModalOpen, setSolutionModalOpen] = useState(false);
    const [pointsModalOpen, setPointsModalOpen] = useState(false);
    const [reportOpen, setReportOpen] = useState(false);
    const [mapOpen, setMapOpen] = useState(false);
    const [solutionModalEnabled, setSolutionModalEnabled] = useState(true);

    const openPointsModal = () => {
        setPointsModalOpen(true);
    };

    const closePointsModal = () => {
        window.scrollTo(0, 0);
        setPointsModalOpen(false);
    };

    const state = {
        solutionModalOpen,
        pointsModalOpen,
        reportOpen,
        mapOpen,
        solutionModalEnabled,
    };

    return {
        ...state,
        setSolutionModalOpen,
        setReportOpen,
        setMapOpen,
        openPointsModal,
        closePointsModal,
        setSolutionModalEnabled,
    };
}

export const { ContextProvider: ZdarKidsGameContextProvider, Context: ZdarKidsGameContext } =
    genericHookContextBuilder(useGame);
